namespace advisorop.components.common {

    export class AccountFilterController {

        filterChangeEvent: any;
        filterObject: domains.IAccountFilter;

        lovs: Array<domains.ILOV> = [];
        custodians: Array<domains.ICustodian>;
        accountTypes: Array<domains.ILOV> = [];
        advisoryFirmMgtRoles: Array<domains.ILOV> = [];
        contractProductTypes: Array<domains.ILOV> = [];
        filterAUMFeeableOnly: boolean = false;
        filterManualAccountsOnly: boolean = false;
        filterByCustodian: boolean = false;
        filterByAccountType: boolean = false;
        filterByAdvisoryFirmMgtRole: boolean = null;
        filterByContractAccount: boolean = null;

        selCustodian: domains.ICustodian;
        selAccountType: domains.ILOV;
        selAdvisoryFirmMgtRole: domains.ILOV;
        selContractProductType: domains.ILOV;

        static $inject = ["generalService", "advisorService"];
        constructor(private generalService: services.GeneralService, private advisorService: services.AdvisorService) {
        }

        reload(): void {
            this.filterChangeEvent();
        }

        toggleFilterAUMFeeableOnly(): void {
            this.filterObject.aumFeeableOnly = this.filterAUMFeeableOnly;
        }

        toggleFilterManualAcccountsOnly(): void {
            this.filterObject.manualAccountsOnly = this.filterManualAccountsOnly;
        }

        toggleFilterByCustodian(): void {
            if (!this.filterByCustodian) {
                this.selCustodian = null;
                this.filterObject.custodianId = null;
            }
        }
        custodianFilterChanged(): void {
            this.filterObject.custodianId = this.selCustodian.id;
        }

        toggleFilterByAccountType(): void {
            if (!this.filterByAccountType) {
                this.selAccountType = null;
                this.filterObject.accountTypeId = null;
            }
        }
        accountTypeFilterChanged(): void {
            this.filterObject.accountTypeId = this.selAccountType.value;
        }

        toggleFilterByAdvisoryFirmMgtRole(): void {
            if (!this.filterByAdvisoryFirmMgtRole) {
                this.selAdvisoryFirmMgtRole = null;
                this.filterObject.advisoryFirmMgtRoleId = null;
            }
        }
        advisoryFirmMgtRoleFilterChanged(): void {
            this.filterObject.advisoryFirmMgtRoleId = this.selAdvisoryFirmMgtRole.value;
        }

        toggleFilterByContractAccount(): void {
            if (!this.filterByContractAccount) {
                this.selContractProductType = null;
                this.filterObject.productTypeId = null;
            }
        }
        contractProductTypeFilterChanged(): void {
            this.filterObject.productTypeId = this.selContractProductType.value;
        }

        getCustodians(): void {
            this.advisorService.getCustodians()
                .success((data) => {
                    this.custodians = data;
                })
                .error((status, data) => {
                    toastr.error("GET CUSTODIANS ERROR " + status + " " + data);
                });
        };

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {
                    this.lovs = data;
                    this.accountTypes = this.lovs.filter(v => v.lovType == domains.LovType.ACCOUNT_TYPE);
                    this.advisoryFirmMgtRoles = this.lovs.filter(v => v.lovType == domains.LovType.ADVISORY_FIRM_MGT_ROLE);
                    this.contractProductTypes = this.lovs.filter(v => v.lovType == domains.LovType.PRODUCT_TYPE && (v.value == domains.ProductType.ANNUITY || v.value == domains.ProductType.LIFE_INSURANCE || v.value == domains.ProductType.OTHER_INSURANCE));
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        $onInit(): void {
            this.loadLovs();
            this.getCustodians();
        }
    }
    
    class AccountFilter implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {      
                filterChangeEvent: "&",
                filterObject: "<"
            };
            this.controller = AccountFilterController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/shared/common/account-filter.html";
        }
    }
    angular.module(Constants.APP).component("accountFilter", new AccountFilter());

}